import { default as s } from "./fonts.js";
import { default as l } from "./fontSizes.js";
import { default as d } from "./fontWeights.js";
import { default as i } from "./lineHeights.js";
import { default as u } from "./radii.js";
import { default as c } from "./shadows.js";
import { default as h } from "./spacings.js";
import { default as z } from "./icons.js";
import o from "./colors/index.js";
const r = {
  ...o
};
export {
  r as colors,
  l as fontSizes,
  d as fontWeights,
  s as fonts,
  z as icons,
  i as lineHeights,
  u as radii,
  c as shadows,
  h as spacings
};
